import { Wallet } from "lucide-react";
import { useProfile } from "@/hooks/useProfile";
import { useAuth } from "@/hooks/useAuth";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { generateDemoTransactions, calculateCurrentBalance } from "@/data/demoWalletData";

export const HeaderWallet = () => {
  const { user } = useAuth();
  const { profile } = useProfile(user?.id);
  
  // Use the demo transactions to calculate the current balance
  const transactions = generateDemoTransactions();
  const currentBalance = calculateCurrentBalance(transactions);

  if (!profile) return null;

  const isAboveThreshold = Number(currentBalance) >= 35;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={cn(
            "flex items-center gap-2 px-3 py-1.5 rounded-md transition-colors cursor-default",
            isAboveThreshold 
              ? "bg-green-500/10 hover:bg-green-500/20" 
              : "bg-yellow-500/10 hover:bg-yellow-500/20"
          )}>
            <Wallet className={cn(
              "h-4 w-4",
              isAboveThreshold ? "text-green-500" : "text-yellow-500"
            )} />
            <span className={cn(
              "text-sm font-semibold",
              isAboveThreshold ? "text-green-500" : "text-yellow-500"
            )}>
              €{currentBalance}
            </span>
          </div>
        </TooltipTrigger>
        <TooltipContent className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-gray-800 shadow-lg">
          <p>Your current balance</p>
          {!isAboveThreshold && (
            <p className="text-xs text-muted-foreground">Available for withdrawal at €35</p>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};